import { useContext } from 'react'

import {
  OneOnOnesContext,
  type OneOnOnesContextState,
} from 'modules/meetings/lib/context/OneOnOnesContext'

export const useOneOnOnesContext = (): OneOnOnesContextState => {
  const context = useContext(OneOnOnesContext)

  if (context === undefined) {
    throw new Error('useOneOnOnesContext must be used within a OneOnOnesContextProvider')
  }

  return context
}
